import React from 'react'
import RegisterForm from '../../components/auth/RegisterForm'

function RegisterPage() {
	return (
		<div>
			<RegisterForm />
		</div>
	)
}

export default RegisterPage
